export default __webpack_public_path__ + "static/media/40.498e145f.jpg";